<script>
export default {};
</script>

<template>
  <card :title="'Relatório de Pagamentos'">
  </card>
</template>
